import { apiConfig } from "./config";
import { adminAuthStorage, visitorAuthStorage } from "./authStorage";
import { ApiError } from "./client";

type DownloadOptions = {
  audience?: "visitor" | "admin";
  filename?: string;
};

export async function apiDownload(path: string, options: DownloadOptions = {}): Promise<void> {
  const storage = options.audience === "admin" ? adminAuthStorage : visitorAuthStorage;
  const token = storage.getToken();

  const headers: Record<string, string> = {
    Accept: "text/csv, application/octet-stream",
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${apiConfig.baseUrl}${path}`, { headers });

  if (!response.ok) {
    let body: unknown;
    try {
      body = await response.json();
    } catch {
      body = undefined;
    }
    throw new ApiError(`API ${response.status}: ${path}`, response.status, body);
  }

  const blob = await response.blob();
  const filename =
    options.filename ??
    response.headers.get("Content-Disposition")?.match(/filename="([^"]+)"/)?.[1] ??
    "export.csv";

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
